var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToTuPinezka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.26 740.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.13,0C201.68,0,118.64,83.04,118.64,185.49s185.49,368.89,185.49,368.89c0,0,185.49-266.44,185.49-368.89S406.57,0,304.13,0ZM304.13,276.35c-50.87,0-92.12-41.24-92.12-92.11s41.25-92.11,92.12-92.11,92.11,41.24,92.11,92.11-41.24,92.11-92.11,92.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.26,740.01H0l23.61-164.31h112.33c14.24,0,25.77-11.54,25.77-25.77s-11.53-25.77-25.77-25.77H31.02l10.45-72.73h148.72c56.59,97.34,113.93,179.71,113.93,179.71,0,0,57.34-82.37,113.94-179.71h148.72l23.12,160.85h-160.2c-14.23,0-25.77,11.54-25.77,25.77s11.54,25.77,25.77,25.77h167.61l10.95,76.19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToTuPinezka);
export default __webpack_public_path__ + "static/media/ToTuPinezka.ca42265543c7dc2e7032c1e21242df0a.svg";
export { ForwardRef as ReactComponent };